import React from "react";

const StudentSheet = () => {
  const headerCellStyle = {
    border: "1px solid #CCC",
    padding: "8pt",
    backgroundColor: "#B8BABA",
    textAlign: "left",
  };

  const cellStyle = {
    border: "1px solid #CCC",
    padding: "8pt",
  };

  return (
    <div
      className="pdf-page"
      style={{
        width: "100%",
        maxWidth: "210mm",
        minHeight: "297mm",
        background: "white",
        margin: "20px auto",
        padding: "8mm",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        boxSizing: "border-box",
        border: "1px solid #ccc",
        overflow: "hidden",
        pageBreakInside: "avoid",
        pageBreakAfter: "always",
      }}
    >
      <div
        style={{
          marginBottom: "0px",
          border: "1px solid #e0e0e0",
          borderRadius: "10px",
          padding: "8px",
          background: "#f9f9f9",
        }}
      >
        <h2
          style={{
            marginBottom: "10pt",
            color: "white",
            fontWeight: "bold",
            backgroundColor: "#50B6F2",
            paddingLeft: "8px",
          }}
        >
          INTERPRETATIVE SHEETS
        </h2>
        <p style={{ margin: "5pt 0", lineHeight: 1.4 }}>
          To assist you in interpreting the report, please refer to the grey shaded pages.
        </p>

        <h4 style={{ marginTop: "20pt", marginBottom: "10pt", fontWeight: "bold" }}>
          Academic Achievement Scale
        </h4>
        <p style={{ margin: "5pt 0", lineHeight: 1.4 }}>
          Listed below are the Rating Keys for <i>Academic Achievement</i>:
        </p>

        <table style={{ borderCollapse: "collapse", width: "100%", marginTop: "10pt" }}>
          <thead>
            <tr>
              <th style={headerCellStyle}>Scale</th>
              <th style={headerCellStyle}>Grade</th>
              <th style={headerCellStyle}>Learning Tasks Scale</th>
            </tr>
          </thead>
          <tbody>
            {[
              ["95-100", "A+", "EXCELLENT standard in ALL knowledge, skills, and understanding."],
              ["85-94", "A", "HIGH standard in MOST knowledge, skills, and understanding."],
              ["80-84", "B+", "VERY GOOD standard in MOST knowledge, skills, and understanding."],
              ["75-79", "B", "GOOD standard in MOST knowledge, skills, and understanding."],
              ["65-74", "C+", "SATISFACTORY in MOST knowledge, skills, and understanding."],
              ["60-64", "C", "SATISFACTORY in SOME knowledge, skills, and understanding."],
              ["0-59", "D", "BELOW standard, needs improvement in MANY areas."],
            ].map(([scale, grade, description]) => (
              <tr key={grade}>
                <td style={cellStyle}>{scale}</td>
                <td style={cellStyle}>{grade}</td>
                <td style={cellStyle}>{description}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p style={{ marginTop: "14pt", lineHeight: 1.4 }}>
          A summative grade is calculated based on all the reported skills and assessments. It is intended to encapsulate as clearly as possible your child’s academic achievement so far this year.
        </p>
      </div>
    </div>
  );
};

export default StudentSheet;
